import styled from "styled-components";
import { Button } from '@mui/material';

export const StoreBox = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: 1140px;
    width: 100%;
    margin: 2rem auto 2rem auto;
    gap: 20px;
    @media (max-width: 768px) {
        width: 94%;
    }
`;

export const StoreGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 1.5px;

    @media (max-width: 1024px) {
        grid-template-columns: repeat(4, 1fr);
    }

    @media (max-width: 768px) {
        grid-template-columns: repeat(3, 1fr);
    }
`;

export const StoreCardWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1.5px solid lightgray; 
    padding: 25px 15px;
    cursor: pointer;
    margin-right: 20px;
    margin-bottom: 10px;

    @media (max-width: 768px) {
        border: 1px solid #0086CA;
        border-radius: 6px;
        padding: 0px;
        margin: 3px;
    }
`;

export const CardWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
`;

export const StoreImage = styled.img`
    width: 100px;
    height: auto;

    @media (max-width: 768px) {
        width: 80%;
    }
`;

export const CashbackButton = styled(Button)`
    && {
        background-color: #4196cb;
        color: white;
        font-weight: 900;
        font-family: 'Lato', sans-serif;
        text-transform: none;

        &:hover {
        background-color: #3170a6;
        }

        @media (max-width: 768px) {
            background-color: transparent !important;
            color: #4196cb !important; 
            box-shadow: none !important;
            &:hover {
                background-color: rgba(65, 150, 203, 0.1); 
            }
        }
    }
`;
